import { createContext, useContext, useMemo, type ReactNode } from "react";
import { DEFAULT_CLASSNAMES } from "./classes";
import type { TerminalClassNames, TerminalTheme } from "./tokens";

interface ThemeContextValue {
  classNames: TerminalClassNames;
}

const ThemeContext = createContext<ThemeContextValue>({
  classNames: DEFAULT_CLASSNAMES,
});

export function TerminalThemeProvider({
  theme,
  children,
}: {
  theme?: TerminalTheme;
  children: ReactNode;
}) {
  const value = useMemo<ThemeContextValue>(
    () => ({
      classNames: { ...DEFAULT_CLASSNAMES, ...(theme?.classNames ?? {}) },
    }),
    [theme],
  );
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

/** Returns the fully-resolved slot class map (defaults merged with overrides). */
export function useTerminalClasses(): TerminalClassNames {
  return useContext(ThemeContext).classNames;
}
